export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/system/public/images/query`,
          data
        });
      },

      save(data) {
          return http.json({
              url: '/system/public/images/save',
              data
          })
      },
      getInfo(data) {
          return http.json({
              url: `/system/public/images/get?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      delete(data) {
          return http.json({
              url: `/system/public/images/delete?id=${data[0].id}`,
              data
          })
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/publicImage.js